type CursorListingPagination = {
  next: string | null;
  previous: string | null;
  count: number;
};

export type CursorListingApiPayload<TRow, TFilterCounts = unknown> = {
  results?: TRow[];
  pagination?: Partial<CursorListingPagination>;
  filter_counts?: TFilterCounts;
};

export type ParsedCursorListingResult<TRow, TFilterCounts = unknown> = {
  rows: TRow[];
  totalCount: number;
  nextCursor: string | null;
  previousCursor: string | null;
  filterCounts?: TFilterCounts;
};

export function parseCursorListingResponse<TRow, TFilterCounts = unknown>(
  data: CursorListingApiPayload<TRow, TFilterCounts> | null | undefined,
): ParsedCursorListingResult<TRow, TFilterCounts> {
  const results = data?.results ?? [];
  const pagination = data?.pagination ?? {};
  return {
    rows: results,
    totalCount: pagination.count ?? results.length,
    nextCursor: pagination.next ?? null,
    previousCursor: pagination.previous ?? null,
    filterCounts: data?.filter_counts,
  };
}

type OffsetListingApiPayload<TRow, TFilterCounts = unknown> = {
  results?: TRow[];
  count?: number;
  filter_counts?: TFilterCounts;
};

/** Standard DRF-style `{ count, results }` offset pagination response. */
export function parseOffsetListingResponse<TRow, TFilterCounts = unknown>(
  data: OffsetListingApiPayload<TRow, TFilterCounts> | null | undefined,
): ParsedCursorListingResult<TRow, TFilterCounts> {
  const results = data?.results ?? [];
  return {
    rows: results,
    totalCount: data?.count ?? results.length,
    nextCursor: null,
    previousCursor: null,
    filterCounts: data?.filter_counts,
  };
}

/** `no_page=true` responses have results only (no pagination object). */
export function parseNoPageListingResponse<TRow, TFilterCounts = unknown>(
  data: CursorListingApiPayload<TRow, TFilterCounts> | null | undefined,
): ParsedCursorListingResult<TRow, TFilterCounts> {
  const results = data?.results ?? [];
  return {
    rows: results,
    totalCount: results.length,
    nextCursor: null,
    previousCursor: null,
    filterCounts: data?.filter_counts,
  };
}
